import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import Fade from '@mui/material/Fade';
import { useTranslate } from '@mui/docs/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BackToTop() {
  var t = useTranslate();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var handleClose = function handleClose() {
    setOpen(false);
  };
  var handleOpen = function handleOpen() {
    setOpen(true);
  };
  var trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 200
  });
  var handleClick = function handleClick() {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var behavior = prefersReducedMotion.matches ? 'auto' : 'smooth';
    window.scrollTo({
      top: 0,
      behavior: behavior
    });
    setOpen(false);
  };
  return /*#__PURE__*/_jsx(Fade, {
    "in": trigger,
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: "Scroll to top",
      placement: "left",
      open: open,
      onClose: handleClose,
      onOpen: handleOpen,
      children: /*#__PURE__*/_jsx(Box, {
        className: "mui-fixed",
        sx: {
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 10
        },
        children: /*#__PURE__*/_jsx(Fab, {
          size: "small",
          "aria-label": t('backToTop'),
          onClick: handleClick,
          "data-ga-event-category": "docs",
          "data-ga-event-action": "click-back-to-top",
          sx: function sx(theme) {
            return _extends({
              backgroundColor: (theme.vars || theme).palette.primary[50],
              border: "1px solid ".concat((theme.vars || theme).palette.primary[200]),
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              '&:hover': {
                backgroundColor: (theme.vars || theme).palette.primary[200]
              }
            }, theme.applyDarkStyles({
              backgroundColor: (theme.vars || theme).palette.primary[900],
              borderColor: (theme.vars || theme).palette.primary[700],
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.8)",
              '&:hover': {
                backgroundColor: (theme.vars || theme).palette.primary[800]
              }
            }));
          },
          children: /*#__PURE__*/_jsx(KeyboardArrowUpRoundedIcon, {
            sx: function sx(theme) {
              return _extends({
                color: (theme.vars || theme).palette.primary[800]
              }, theme.applyDarkStyles({
                color: (theme.vars || theme).palette.primary[200]
              }));
            }
          })
        })
      })
    })
  });
}